import AddJobTitleForm from "./AddJobTitleForm";

export default AddJobTitleForm;